class MediaThumbnails extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.revealImage = this.revealImage.bind(this)

    if (window.BAO.MediaBreakpoints.isMd) {
      this.els?.thumbnail?.elements.forEach((thumbnailEl) => {
        this.listeners.add(thumbnailEl, 'click', this.revealImage)
      })
    }

    this.initGalleryObserver()
  }

  revealImage (event) {
    const index = event.target.closest('[data-media-thumbnails-el="thumbnail"]')
      .dataset.index
    const media = this.externalEls.image.elements[index]
    if (media) {
      media.scrollIntoView({
        behavior: 'smooth',
        inline: 'nearest',
        block: 'start',
      })
    }
  }

  initGalleryObserver () {
    const options = {
      root: this.externalEls.image.container,
      rootMargin: '0px 0px -70% 0px',
      threshold: 0,
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = Array.from(this.externalEls.image.elements).indexOf(
            entry.target,
          )

          if (index > -1) {
            this.els.thumbnail.elements.forEach((thumbnailEl) => {
              thumbnailEl.classList.remove('prd-Thumbnails_Image-active')
            })
            this.els.thumbnail.elements[index].classList.add(
              'prd-Thumbnails_Image-active',
            )
          }
        }
      })
    }, options)

    this.externalEls.image.elements.forEach((img) => observer.observe(img))
  }
}

if (!customElements.get('media-thumbnails')) {
  customElements.define('media-thumbnails', MediaThumbnails)
}
